/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesBlockElementTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Element Type Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, September 27, 2018 - 11:47:40 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/27/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const BlockElementTypeList = Loadable({
    loader: () => import('../containers/BlockElementTypes/BlockElementTypeListContainer'),
    loading: Loading,
});

export const BlockElementTypeForm = Loadable({
    loader: () => import('../containers/BlockElementTypes/BlockElementTypeEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesBlockElementTypes.js